import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref } from "vue"

import { ref, watchEffect } from "vue";
import {
  deleteUserUsingPost,
  listUserByPageUsingPost,
} from "@/api/userController";
import API from "@/api";
import { Message } from "@arco-design/web-vue";
import { dayjs } from "@arco-design/web-vue/es/_utils/date";
import {
  deleteQuestionUsingPost,
  listQuestionByPageUsingPost,
} from "@/api/questionController";

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminQuestionPage',
  setup(__props) {

const initSearchParams = { current: 1, pageSize: 10 };
const searchParams = ref<API.UserQueryRequest>({
  ...initSearchParams,
});

const dataList = ref<API.User[]>([]);
const total = ref<number>(0);
const formSearchParams = ref<API.UserQueryRequest>({});

/*
 * 加载数据
 * */
const loadData = async () => {
  const res = await listQuestionByPageUsingPost(searchParams.value);
  if (res.data.code === 0) {
    dataList.value = res.data.data?.records || [];
    total.value = res.data.data?.total || 0;
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

/*
 * 数据删除
 * */
const doDelete = async (record: API.User) => {
  const res = await deleteQuestionUsingPost({
    id: record.id,
  });
  if (res.data.code === 0) {
    Message.success("删除成功");
    await loadData();
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

/*
 * 监听数据
 * */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/*
 * 执行搜索
 * */

const doSearch = () => {
  searchParams.value = {
    ...initSearchParams,
    ...formSearchParams.value,
  };
};

watchEffect(() => {
  loadData();
});

const columns = [
  {
    title: "id",
    dataIndex: "id",
  },
  {
    title: "题目内容",
    dataIndex: "questionContent",
    slotName: "questionContent",
  },
  {
    title: "应用id",
    dataIndex: "appId",
  },
  {
    title: "用户id",
    dataIndex: "userId",
  },
  {
    title: "创建时间",
    slotName: "createTime",
  },
  {
    title: "更新时间",
    slotName: "updateTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: formSearchParams.value,
      style: {"margin-bottom":"20px"},
      layout: "inline",
      onSubmit: doSearch
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "userName",
          label: "用户名"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formSearchParams.value.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSearchParams.value.userName) = $event)),
              placeholder: "请输入用户名",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userProfile",
          label: "用户简介"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formSearchParams.value.userProfile,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSearchParams.value.userProfile) = $event)),
              placeholder: "请输入用户简介",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("搜索")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
      showTotal: true,
      pageSize: searchParams.value.pageSize,
      current: searchParams.value.current,
      total: total.value,
    },
      onPageChange: onPageChange
    }, {
      questionContent: _withCtx(({ record }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(record.questionContent), (question) => {
          return (_openBlock(), _createElementBlock("div", {
            key: question.title
          }, _toDisplayString(question.title), 1))
        }), 128))
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      updateTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.updateTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              status: "danger",
              onClick: ($event: any) => (doDelete(record))
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("删除")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ], 64))
}
}

})